import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import { BACKEND_URL } from '../app.config';
import { VisaBulletin, VisaBulletinListFilter } from '../api/data-model';

@Injectable()
export class VisaBulletinService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  getList(filter: any, sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<VisaBulletin>> {
    return this.http.get<ListResult<VisaBulletin>>(this.baseUrl + '/api/app/visa-bulletin', {
      params: {
        type: filter.type ?? '',
        currentUpcoming: filter.currentUpcoming ?? '',
        month: filter.month ?? '',
        sorting,
        skipCount,
        maxResultCount,
      },
    });
  }

  create(month: string) {
    return this.http.post(`${this.baseUrl}/api/app/visa-bulletin`, { month });
  }

  bulkUpdate(visaBulletins: VisaBulletin[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/app/visa-bulletin/bulk-update`, {visaBulletins});
  }

   update(visaBulletin: VisaBulletin): Observable<VisaBulletin> {
   return this.http.put<VisaBulletin>(`${this.baseUrl}/api/app/visa-bulletin/${visaBulletin.id}`, visaBulletin);
 }
}
